import React from "react";
import { Dialog } from "primereact/dialog";
import { AlignContent } from "./Cards";
import { MainButton } from "./Buttons";
export default function MainModel({
  visible,
  setVisible,
  title,
  subTitle,
  onSave,
  saveLabel,
  disableAction,
  onCancel,
  children,
  isDelete,
  closable=false,
  extraClass
}) {
  const headerTemplate = () => {
    return (
      <>
        {title && <h4 className="m-0">{title}</h4>}
        {subTitle && <p className="mb-0">{subTitle}</p>}
      </>
    );
  };

  return (
    <Dialog
      header={headerTemplate}
      visible={visible}
      className={`md:w-4 w-10 bg-white ${extraClass}`}
      onHide={() => {
        if (!visible) return;
        setVisible(false);
      }}
      closable={closable ? false : true}
    >
      <>{children}</>
      <AlignContent horizontal="end" extraClass="gap-3 mt-3 p-2">
        {onCancel && (
          <MainButton
            label="Cancel"
            onClick={() => {
              setVisible(false);
              onCancel();
            }}
            position="max-w-max"
            secondary
          />
        )}
        {onSave && (
          <MainButton
            label={isDelete ? "Delete" : saveLabel ? saveLabel :"Save Changes"}
            onClick={onSave}
            position="max-w-max"
            extraClass={isDelete && "bg-red-600"}
            disabled={disableAction}
          />
        )}
      </AlignContent>
    </Dialog>
  );
}
